import React from 'react';
import { Form, Input, Select, Button, Row, Col, Table, Space, Modal, message, Popconfirm, Badge, ConfigProvider, Pagination } from 'antd';
import './../../../../../index.scss';
import zhCN from 'antd/lib/locale/zh_CN';
import { nodeService } from '../../../../services/node.service';
import { algorithmService } from '../../../../services/algorithm-manage';
import { labelService } from '../../../../services/label.service';
import { otaService } from '../../../../services/ota.service';
import { firmwareService } from '../../../../services/firmware.service'
import BackPage from '../../../common/backPage';

import { MinusCircleOutlined, PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
const { Option } = Select;
const { confirm } = Modal;

let flag = false;
let page = 1;
let pageSize = 10;
let searchFirmwareVersion = '';
let searchFirmwareOta = null;
let firmwaresList = [];
let firmLoading = true;
let firmwareAction = null;
function FirmwareModal(props) {
  const [form] = Form.useForm();
  const firmwareColumns = [
    {
      title: 'epack名称',
      dataIndex: 'firmwareName',
      key: 'firmwareName',
    },
    {
      title: 'epack版本',
      dataIndex: 'firmwareVersion',
      key: 'firmwareVersion',
    },
    {
      title: '类型',
      dataIndex: 'isPrivate',
      key: 'isPrivate',
      render: (text, record) => {
          return text===0?'公共版':'专属版'
      }
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
    },
  ];
  const onFinish = (values) => {
    searchFirmwareVersion = values.searchName || '';
    searchFirmwareOta = values.searchOta;
    props.onClick();
  };
  const resetForm = () => {
    form.resetFields();
    searchFirmwareVersion = '';
    searchFirmwareOta = props.defaultSelectValue;
    form.setFieldsValue({ searchOta: props.defaultSelectValue });
    props.onClick();
  }
  const onValuesChange = (value) => {
    const keys = Object.keys(value);
    if (keys.find(elx => elx === 'searchOta')) {
      searchFirmwareVersion = form.getFieldValue('searchName') || '';
      searchFirmwareOta = value.searchOta || '';
      props.onClick();
    }
  }
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // id: selectedRowKeys
      // obj : selectedRows
      firmwareAction = selectedRows;
      console.log(firmwareAction);
    },
  };
  return (
    <>
      {/* <div className="common-search-form">
        <Form
          form={form}
          name="advanced_search"
          className="ant-advanced-search-form"
          onFinish={onFinish}
          initialValues={{ 'searchOta': props.defaultSelectValue }}
          onValuesChange={onValuesChange} >
          <Col span={24} offset={2}>
            <Form.Item name='searchOta' label='所属产品'
              style={{ float: 'left', marginRight: '7.14px' }}
            >
              <Select style={{ width: '150px' }} placeholder="请选择所属产品"
              >
                {props.otaList}
              </Select>
            </Form.Item>
            <Form.Item name='searchName' label='epack版本' style={{ float: 'left', marginRight: '7.14px' }}>
              <Input style={{ width: 150 }} placeholder="请输入关键字" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit"> 查询 </Button>
              <Button style={{ margin: '0 9.46px' }} onClick={resetForm}>重置 </Button>
            </Form.Item>
          </Col>
        </Form>
      </div> */}
      <Table
        rowSelection={{
          type: 'radio',
          ...rowSelection,
        }}
        rowKey={record => record.id}
        pagination={false}
        loading={props.firmLoading}
        scroll={{ y: 360 }}
        columns={firmwareColumns} dataSource={firmwaresList} />
    </>
  );
}


class AlgorithmInstall extends React.Component {
    state = {
        isFirmwareVisible: false,
        firmLoading: true,
        nodeName: this.props?.location.state?.name,
        nodeId: this.props?.location.state?.id,
        status: this.props?.location.state?.status,
        firmwareVersion: this.props?.location.state?.firmwareVersion,
        nodeUpgrades: [],

        loading: false,
        page: 1,
        pageSize: 10,
        dataCount: null,

        labelList: [],
        OtadefaultSelectValue: null,
        otaList: [],
    }

    componentDidMount() {
        const nodeId = this.props?.location.state?.id;
        const nodeName = this.props?.location.state?.name;
        const status = this.props?.location.state?.status;
        const firmwareVersion = this.props?.location.state?.firmwareVersion;
        if (nodeId) {
            this.getNodeAlgorithmsUpgradeHistory(nodeId)
            this.backInterval = setInterval(()=>{
              this.getNodeAlgorithmsUpgradeHistory(nodeId)
            }, 30000)
            sessionStorage.setItem('nodeName', nodeName || '');
            sessionStorage.setItem('nodeId', nodeId || '');
            sessionStorage.setItem('status', status || '');
            sessionStorage.setItem('firmwareVersion', firmwareVersion || '');
            //this.getLicensesInfo(nodeId);
        } else {
            if (sessionStorage.getItem('nodeId')) {
                const nodeId = sessionStorage.getItem('nodeId');
                const nodeName = sessionStorage.getItem('nodeName');
                const status = sessionStorage.getItem('status');
                const firmwareVersion = sessionStorage.getItem('firmwareVersion');
                //this.getLicensesInfo(nodeId);
                this.setState({
                    nodeName: nodeName,
                    nodeId: nodeId,
                    status: status,
                    firmwareVersion: firmwareVersion,
                })
                this.getNodeAlgorithmsUpgradeHistory(nodeId)
                this.backInterval = setInterval(()=>{
                  this.getNodeAlgorithmsUpgradeHistory(nodeId)
                }, 30000)
            }
        }
        pageSize = 10;
        page = 1;
        this.getLabelList();
        this.getOtaList(); // 选择所属产品
        
    }
    
    getLabelList() {
      labelService.getAllLabels().then(res => {
        if (res.code === 200) {
          const labels = res.labels;
          this.setState({
            labelList: this.getLableItem(labels)
          });
        }
      }, error => {
        error && message.error(error);
      });
    }
    
    getLableItem(labels) {
      return labels.map((item, index) => {
        return (
          <Option key={item.id} >{item.name}</Option>
        );
      });
    }
  
    getOtaList() {//FIXME:
      otaService.getAllOtaList().then(res => {
        if (res.code === 200) {
          console.log('产品列表', res.products);
          const products = res.products;
          this.setState({
            otaList: this.getOtaItem(products),
            OtadefaultSelectValue: products[0]?.id
          });
        }
      }, error => {
        error && message.error(error);
      });
    }
    
    getOtaItem(products) {
      return products.map((item, index) => {
        return (
          <Option key={item.id} value={item.id}>{item.productName}</Option>
        );
      });
    }

    componentWillUnmount() {
        page = 1;
        pageSize = 10;
        sessionStorage.removeItem('nodeId');
        sessionStorage.removeItem('nodeName');
        sessionStorage.removeItem('status');
        sessionStorage.removeItem('firmwareVersion');
        clearInterval(this.backInterval)
    }
    
    // getFirmwareList() {
    //   if (this.state.OtadefaultSelectValue) {
    //     this.setState({
    //       firmLoading: true,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
    //     })
    //     firmwareService.getAllFirmwareByOta(searchFirmwareOta || this.state.OtadefaultSelectValue, '', searchFirmwareVersion).then(res => {
    //       this.setState({
    //         firmLoading: false
    //       })
    //       if (res.code === 200) {
    //         console.log('epack信息', res.firmwares);
    //         firmwaresList = res.firmwares;
    //         this.setState({
    //           isFirmwareVisible: true,
    //         });
    //       } else {
    //         message.error('获取epack列表失败，' + res.message);
    //       }
    //     }, error => {
    //       this.setState({
    //         firmLoading: false
    //       })
    //       error && message.error(error);
    //     });
    //   } else {
    //     message.info('没有可选择epack')
    //   }
  
    // }
    
    //节点推送升级记录查询
    getNodeAlgorithmsUpgradeHistory(id) {
      this.setState({
        loading: true,
        page,
        pageSize
      })
      nodeService.getNodeAlgorithmsUpgradeHistory(id, pageSize, page).then(res => {
        if (res.code === 200) {
          console.log('节点算法升级记录查询', res);
          const nodeUpgrades = res.nodeUpgrades;
          this.setState({
            nodeUpgrades,
            loading: false,
            dataCount: res.dataCount,
          });
        }
      }, error => {
        error && message.error(error);
      });
    }
    
    //添加推送升级
    addNodeAlgorithmsUpgrade(){
      console.log(firmwareAction[0].id);
      console.log(this.state.nodeId);
      this.setState({
        loading: true
      })
      nodeService.addNodeAlgorithmsUpgrade(this.state.nodeId, firmwareAction[0].id).then(res => {
        if (res.code === 200) {
          message.success("添加成功!")
          this.getNodeAlgorithmsUpgradeHistory(this.state.nodeId)
        }
      }, error => {
        error && message.error(error);
      });
    }
    
    //删除推送升级
    deleteNodeAlgorithmsUpgrade(id){
      this.setState({
        loading: true
      })
      nodeService.deleteNodeAlgorithmsUpgrade(id).then(res => {
        if (res.code === 200) {
          message.success("删除成功!")
          this.getNodeAlgorithmsUpgradeHistory(this.state.nodeId)
        }
      }, error => {
        error && message.error(error);
      });
    }

    showAddConfirm() {
        this.setState({
          isFirmwareVisible: true,
          firmLoading: true,
        })
      
        nodeService.getUpgradeFirmwares(this.state.nodeId).then(res => {
          if (res.code === 200) {
            firmwaresList = res.firmwares;
            console.log("epack数据：", res.firmwares);
            this.setState({
              firmLoading: false,
            });
          }
          //  else {
          //   message.error('获取epack列表失败，' + res.message);
          //   this.setState({
          //     firmLoading: false,
          //   });
          // }
        }, error => {
          this.setState({
            firmLoading: false,
          });
          error && message.error(error);
        });
       
      } 
      
      showDeleteConfirm(event) {
        confirm({
          title: '确定删除吗?',
          icon: <ExclamationCircleOutlined />,
          content: <p style={{ color: '#ffb051' }}>删除之后不可恢复，请谨慎操作！</p>,
          closable: true,
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            this.deleteNodeAlgorithmsUpgrade(event.id)
            
          },
          onCancel() {
    
          },
        });
      }
  
      getState(record) {
        // f (record.state === 'WAITING') {
        //     return <div><div className="common-yellow"></div> <span>待升级</span></div>
        //   } 
        if (record === 'UNCONNECTED') {
          return <div><div className="common-deep-gray"></div> <span>未纳管</span></div>
        } else if (record === 'RUNNING') {
          return <div><div className="common-green"></div> <span>运行中</span></div>
        } if (record === 'UPGRADEWAITING') {
          return <div><div className="common-yellow"></div> <span>待升级</span></div>
        } else if (record === 'UPGRADING') {
          return <div><div className="common-yellow"></div> <span>升级中</span></div>
        } else if (record === 'DISABLED') {
          return <div><div className="common-gray"></div> <span>禁用</span></div>
        } else if (record === 'OFFLINE') {
          return <div><div className="common-red"></div> <span>不在线</span></div>
        } else if (record === 'DELETED') {
          return <div><div className="common-red"></div> <span>已删除</span></div>
        } else {
          return '';
        }
      }
  
    //匹配升级任务状态
    getType = (record) => {
      if (record.state === 'SUCCESS') {
        return <span><Badge status="success" />升级成功</span>
      }
      else if (record.state === 'FAILED') {
        return <span><Badge status="error" />升级失败</span>
      }
      else if (record.state === 'WAITING') {
        return <span><Badge status="warning" />待升级</span>
      }
      else if (record.state === 'UPGRADING') {
        return <span><Badge status="warning" />升级中</span>
      }
    }
  
    getOperByRecordState(text, record) {
      return (
        <>
          {
            record.state === 'WAITING' ?
              <a href onClick={() => this.showDeleteConfirm(record)} style={{ marginRight: '5px' }}>删除</a>
              : ''
          }
          
        </>
      );
    }

    //弹窗的取消设置
    handleCancel = () => {
        this.setState({
          isFirmwareVisible: false,
        })
    }
  
    handleFirmwareOk = () => {
        this.addNodeAlgorithmsUpgrade()
        this.handleCancel();
      
    }

    goback() {
        firmwareAction = null
        this.props.history.push('/home/node-manage');
    }
    render() {
        const Columns = [
            {
                title: 'epack名称',
                dataIndex: 'firmwareName',
            },
            {
                title: 'epack版本',
                dataIndex: 'firmwareVersion',
            },
            {
                title: '描述',
                dataIndex: 'firmwareDescription',
            },
            {
                title: '状态',
                dataIndex: 'state',
                render: (text, record) => (
                  this.getType(record)
                  )
            },
            {
                title: '安装时间',
                dataIndex: 'updateTime',
            },
            {
                title: '操作',
                dataIndex: 'action',
              render: (text, record) =>(
                // <a href onClick={() => this.showDeleteConfirm(record)}>删除</a>
                <>
                  {this.getOperByRecordState(text, record)}
                </>
              )
            }
          ];
      
          // const onPageChange = (pageNumber,ps) => {
          //   page = pageNumber;
          //   if(ps!=pageSize) {
          //     page = 1
          //   }
          //   pageSize = ps
          //   this.getNodeAlgorithmsUpgradeHistory();
          // }
          
          //分页下拉框获取分页的大小
          const onPageChange = (pageNumber) => {
            page = pageNumber;
            this.getNodeAlgorithmsUpgradeHistory(this.state.nodeId);
          }

          //pageSize 变化的回调
          const onShowSizeChange = (current, pageSizeNumber) => {
            pageSize = pageSizeNumber;
            page = 1;
        
            this.getNodeAlgorithmsUpgradeHistory(this.state.nodeId);
          }


          const formItemLayout = {
            labelCol: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 },
            wrapperCol: { xs: 24, sm: 12, md: 15 },
          };
      
        return (
            <div className="common-pd20">
                <BackPage onClick={() => this.goback()} headeTitle={"推送升级---" + this.state.nodeName} itemTitle="算法安装" itemSubTitle="算法安装" />
                <div className="common-create-center-container">
                    <div className="common-create-page">
                        <div className="job-bottom-card">
                            <Form {...formItemLayout}
                                  labelAlign="left">
                                <Row>
                                    <Col span={14}>
                                      <Form.Item label="状态">
                                        {this.getState(this.state.status)}
                                      </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={14}>
                                      <Form.Item label="当前epack版本">
                                          {this.state.firmwareVersion}
                                      </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                            
                            <Form>
                                <Form.Item label="安装记录">
                                        <Button type="primary" style={{ color: '#fff', width: 110 }} onClick={() => this.showAddConfirm()}> 选择epack版本 </Button>
                                </Form.Item>
                            </Form>
                            
                            <div className="common-center-container" style={{ padding: 0 }}>
                                    <div className="user-table-card">
                                        <Table
                                            rowKey={record => record.id}
                                            bordered={false}
                                            pagination={false}
                                            columns={Columns}
                                            // scroll={{ y: 300 }}
                                            onChange={onPageChange}
                                            loading={this.state.loading}
                                            dataSource={this.state.nodeUpgrades}
                                        />

                                    </div>
                                    <div className="common-bottom-pagination">
                                  <ConfigProvider locale={zhCN}>
                                    <Pagination
                                      showSizeChanger //展示分页切换器
                                      defaultCurrent={1} 
                                      current={this.state.page} 
                                      pageSize={this.state.pageSize} 
                                      total={this.state.dataCount} 
                                      // showTotal={total => `共有${total}条`}
                                      onShowSizeChange={onShowSizeChange} //	pageSize 变化的回调
                                      onChange={onPageChange}   //页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
                                    >
                                    </Pagination>
                                  </ConfigProvider>
                              </div>
                                </div>
                                
                        </div>
                    </div>
                </div>
                {/* 弹窗 */}
                <Modal title="选择升级epack" destroyOnClose visible={this.state.isFirmwareVisible} width={800} onOk={() => this.handleFirmwareOk()} onCancel={() => this.handleCancel()} okText="确定" cancelText="取消">
                  <FirmwareModal otaList={this.state.otaList}
                    defaultSelectValue={this.state.OtadefaultSelectValue}
                    firmLoading={this.state.firmLoading}
                    onClick={() => this.getFirmwareList()} />
                </Modal>
            </div>
        )
    }
}

export default AlgorithmInstall;